<div class="view-port-detect" 
inViewport
[inViewportOptions]="{ threshold: 0.0001 }"
(inViewportAction)="onIntersection($event)">
</div>

<div class="related-wrapper H-100 H-100-full H-m-500-50 position-relative"
(swipeleft)="onSwipeLeft()"
(swiperight)="onSwipeRight()">
    <div class="related-item H-100 H-100-full H-m-500-50 overflow-hidden" 
        [ngClass]="{
            'last-active':lastActive == i,
            'active':activeRelated == i}"  
        *ngFor="let work of works | relatedFilter:tags:title | slice:0:3;  let i = index" >
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 " [ngClass]="{'col-lg-6': screenWidth > 1024}">
                    <div class="row">
                        <div class="w-100 H-100 H-t-50 H-m-500 position-relative grid-item-space">
                            <div class="related-content-holder">
                                <p class="heading5 services-header">RELATED</p>
                                <h1 class="heading1 heading-2-3-m font-bold" [innerHtml]="work.title.rendered"></h1>
                                <h3 class="heading3 f-darker" [innerHtml]="work.acf.subtitle"></h3>
                                <a class="link1 link-darker" (click)="handleAnimation(work)"  [ngClass]="{'d-none':screenWidth <= 1024}">View work</a>
                                
                            </div>
                            <div class="dots-wrapper related-dots-wrapper" *ngIf="screenWidth <= 1024">
                                <a (click)="activeSlide(i)" class="gallery-dots"  *ngFor="let work of works | relatedFilter:tags:title | slice:0:3;  let i = index">
                                    <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                                        <mat-progress-bar *ngIf="activeRelated == i" mode="determinate" value="{{width}}"></mat-progress-bar>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12"  [ngClass]="{'col-md-6': screenWidth > 1024}">
                    <div class="row">
                        <div class="w-100 H-100 H-t-50 oweflow-hidden related-item-image" [ngClass]="{'grid-item-space': screenWidth > 1024}">
                            <a (click)="handleAnimation(work)">
                               <img id="related-image-{{i}}" (load)="loadedImage(i)" class="related-image" src="{{work.acf.project_modules[0].banner_gallery[0].banner_item}}" alt="">
                               <a class="link1-mobile link-separator link-white" (click)="handleAnimation(work)"  [ngClass]="{'d-none':screenWidth > 1024}">View work</a>
                            </a> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dots-wrapper related-dots-wrapper" *ngIf="screenWidth > 1024">
        <a (click)="activeSlide(i)" class="gallery-dots"  *ngFor="let work of works | relatedFilter:tags:title | slice:0:3;  let i = index">
            <div class="dots-inner-wrapper dark-dots" [ngStyle]="{'width': labelwidth +'px'}">
                <mat-progress-bar *ngIf="activeRelated == i" mode="determinate" value="{{width}}"></mat-progress-bar>
            </div>
        </a>
    </div>
</div>
